const generateLocationString = (suburb, city) => `${suburb}, ${city}`;

export { generateLocationString };
